import React, { useEffect, useState } from "react";
import "./Duval.css";
// import Spinner from "../../components/spinner/Spinner";
import axiosInstance from "../../api/axiosInstance";

const Duval = () => {
  const baseURL = process.env.REACT_APP_BASE_URL;

  // const [loading, setLoading] = useState(true);
  // const [error, setError] = useState(null);
  const [duvalList, setDuvalList] = useState([]);
  // eslint-disable-next-line
  const [offset, setOffset] = useState(0);
  const limit = 20;

  useEffect(() => {
    loadDuvalList(offset, limit); // eslint-disable-next-line
  }, [offset]);

  const loadDuvalList = async (offset = 0, limit = 20) => {
    try {
      // setLoading(true);

      const response = await axiosInstance.get(`${baseURL}api/duval_properties/list-cases?offset=${offset}&limit=${limit}`);
      if (response.status === 200) {
        setDuvalList(response.data.data);
      }
    } catch (err) {
      console.error(err);
      // setError(err);
    } finally {
      // setLoading(false);
    }
  };

  const doLoadCasesManually = async (btn) => {
    try {
      btn.setAttribute("disabled", "disabled");
      btn.style.background = "#555";

      await fetch(baseURL + "api/get-foreclosure-cases");
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div>
      <div className="input_fields_container !flex !flex-row !justify-between">
        {/* <div className="!flex !gap-2">
          <button className="big_button" disabled={offset === 0} onClick={() => setOffset((prev) => Math.max(prev - limit, 0))}>
            Previous
          </button>

          <button className="big_button" onClick={() => setOffset((prev) => prev + limit)}>
            Next
          </button>
        </div> */}
        <div></div>

        <button className="big_button mr20" type="button" onClick={(e) => doLoadCasesManually(e.target)}>
          Force Load
        </button>
      </div>

      <table id="dataTable" className="agent_table aip_table duvalcase_table">
        <thead>
          <tr>
            <th style={{ width: "200px" }}>CaseID / Case Date</th>
            <th>Case Address</th>
            <th>Case Type</th>
            <th style={{ width: "100px", textAlign: "center" }}>Case Status</th>
            <th>Defendants</th>
          </tr>
        </thead>
        <tbody>
          {duvalList &&
            duvalList.map((oneCase, index) => (
              <tr key={index}>
                <td>
                  {oneCase.caseNumber}
                  <br />
                  <br />
                  {oneCase.caseFileDate}
                </td>
                <td>
                  {oneCase.street?.toLowerCase()}, {oneCase.city?.toLowerCase()}, {oneCase.state} {oneCase.zipCode}
                </td>
                <td>{oneCase.caseType}</td>
                <td style={{ textAlign: "center" }}>{oneCase.caseStatus}</td>
                <td>
                  <ul>{oneCase.defendants && oneCase.defendants.length > 0 ? oneCase.defendants.map((oneDef, i) => <li key={i}>{oneDef?.name?.toLowerCase()}</li>) : ""}</ul>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default Duval;
